import { createTheme } from '@mui/material'

const theme = createTheme({
    breakpoints: {
        values: {
            xs: 0,
            sm: 400,
            sm2: 600,
            md: 769,
            lg: 1025,
        },
    },
});

export const ScreenType = (useMediaQuery) => {
    const small = useMediaQuery(theme.breakpoints.down('sm'));
    const small2 = useMediaQuery(theme.breakpoints.down('sm2'));
    const medium = useMediaQuery(theme.breakpoints.down('md'));
    const large = useMediaQuery(theme.breakpoints.down('lg'));
    const xlarge = useMediaQuery(theme.breakpoints.up('lg'));
    if (small) {
        return "s"
    } else if (small2) {
        return "s2"
    } else if (medium) {
        return "m"
    } else if (large) {
        return "l"
    } else if (xlarge) {
        return "xl"
    }
};
